(function($) {
	$(document).ready(function () {

		var $checkbox = $('#accept_terms');
		var $checkoutButton = $('[name="checkout"]');

		// Deshabilitar al cargar
		$checkoutButton.prop('disabled', !$checkbox.is(':checked'));

		// Habilitar/deshabilitar al cambiar el checkbox
		$checkbox.on('change', function () {
			$checkoutButton.prop('disabled', !$(this).is(':checked'));
		});
		$checkoutButton.on('click', function (e) {

			if (!$('#accept_terms').is(':checked')) {
				e.preventDefault();
				alert('Debes aceptar los Términos y Condiciones y las Políticas de Privacidad para continuar.');
			}

		});


	  function change_filters () {
		  setTimeout( function() {
			  var filtros = [];
			  jQuery('.active-facets .active-facets__button').each( function ( index, item ) {
				  if( jQuery(item).text().trim() != 'Borrar todo' ) {
					  filtros.push( jQuery(item).text().trim() );
				  }
			  } );
			  //console.log( 'filtros', filtros );
			  if( filtros.length != 0 ) {
				  jQuery.arrayIntersect = function(a, b) {
					  return $.grep(a, function(i) {
						  return $.inArray(i, b) > -1;
					  });
				  };
				  jQuery('.grid__item.product-grid > li, .row.results-grid.product-grid > li').each( function ( index, item ) {
					  var $tallas_options = $(item).find('.talla.options.indiv-product__swatches .position-relative input');
					  var $colores_options = $(item).find('.color.options.indiv-product__swatches .position-relative input');
					  var tallas_disponibles = [];
					  var colores_disponibles = [];
					  $tallas_options.each( function ( indexTalla, itemTalla ) {
						  tallas_disponibles.push( itemTalla.value );
					  } );
					  $colores_options.each( function ( indexColor, itemColor ) {
						  colores_disponibles.push( itemColor.value );
					  } );


					  //console.log( tallas_disponibles );
					  //console.log( colores_disponibles );

					  //console.log( $.arrayIntersect(filtros, tallas_disponibles) );
					  //console.log( $.arrayIntersect(filtros, colores_disponibles) );

					  if ( $.arrayIntersect(filtros, tallas_disponibles).length == 0 && $.arrayIntersect(filtros, colores_disponibles).length == 0 ) {
						  console.log( "NO HAY", jQuery( item ).find( '.hp-title .indiv-product-title-text').text().trim(), tallas_disponibles, colores_disponibles );
						  jQuery(item).fadeOut(0);
					  }
				  } );
			  } else {
				  jQuery('.grid__item.product-grid > li, .row.results-grid.product-grid > li').fadeIn();
			  }
		  }, 100 );
	  }
	  jQuery(document).on('DOMSubtreeModified', '.active-facets', change_filters );
	  change_filters();

		function sortSizes() {


			var order = [
					'XL','L','M','M/L','S','S/M','XS','44D','44C','44B','44A','44','43D','43C','43B','43A','43','T42D','T42C','T42B','T42A','42D','42C','42B','42A','42','41D','41C','41B','41A','41','T40D','T40C','T40B','T40A','40D','40C','40B','40A','40','39D','39C','39B','39A','39','T38D','T38C','T38B','T38A','38D','38C','38B','38A','38','37D','37C','37B','37A','37','T36D','T36C','T36B','T36A','36D','36C','36B','36A','36','35D','35C','35B','35A','35','T34D','T34C','T34B','T34A','34D','34C','34B','34A','34','33D','33C','33B','33A','33','T32D','T32C','T32B','T32A','32D','32C','32B','32A','32'
				].reverse().map(String); // todo como string

			//NUEVO ORDEN DE TALLAS
			// Buscar el fieldset de Talla
				document.querySelectorAll('fieldset').forEach(fieldset => {
					const legend = fieldset.querySelector('legend');

					if (!legend || !legend.textContent.includes('Talla')) return;

					const ul = fieldset.querySelector('ul');
					if (!ul) return;

					const items = [...ul.children];

					items.sort((a, b) => {
						const aValue = a.querySelector('input').value;
						const bValue = b.querySelector('input').value;

						let aIndex = order.indexOf(String(aValue));
						let bIndex = order.indexOf(String(bValue));

						if (aIndex === -1) aIndex = 9999;
						if (bIndex === -1) bIndex = 9999;

						return aIndex - bIndex;
					});

					items.forEach(item => ul.appendChild(item));
				});
		}
		function hideNAOptions() {

			document.querySelectorAll('fieldset.js-variant-radio-container').forEach(fieldset => {

				// Todos los valores de la opción
				const inputs = fieldset.querySelectorAll('input[type="radio"]');

				// Si solo existe una opción
				if (inputs.length === 1) {
					const value = inputs[0].value.trim().toLowerCase();

					// Si esa única opción es N/A
					if (value === 'n/a') {
						fieldset.style.display = 'none';
					}
				}
			});
		}


		function refreshVariants() {
			sortSizes();
			hideNAOptions();
		}
		refreshVariants();

		const variantId = document.querySelector('.form-control[name="id"], .form__control[name="id"]');

		if (variantId) {
			variantId.addEventListener('change', function () {
				console.log('Variante cambiada:', this.value);
				refreshVariants();
				setTimeout( refreshVariants, 100);
			});
		}

		document.addEventListener('change', function(e) {
			if (!e.target.matches('.form__control[name="id"]')) return;

			const script = document.querySelector('script[data-selected-variant]');
			if (!script) return;

			const variant = JSON.parse(script.textContent);

			document.querySelector('.mi-sku').textContent = `SKU: ${variant.sku}` || '';
		});


		function sortCardSizes() {
			const order = [
				'XL','L','M','M/L','S','S/M','XS','44D','44C','44B','44A','44','43D','43C','43B','43A','43','T42D','T42C','T42B','T42A','42D','42C','42B','42A','42','41D','41C','41B','41A','41','T40D','T40C','T40B','T40A','40D','40C','40B','40A','40','39D','39C','39B','39A','39','T38D','T38C','T38B','T38A','38D','38C','38B','38A','38','37D','37C','37B','37A','37','T36D','T36C','T36B','T36A','36D','36C','36B','36A','36','35D','35C','35B','35A','35','T34D','T34C','T34B','T34A','34D','34C','34B','34A','34','33D','33C','33B','33A','33','T32D','T32C','T32B','T32A','32D','32C','32B','32A','32'
			].reverse().map(String);

			document.querySelectorAll('[data-variable="talla"]').forEach(container => {

				const buttons = [...container.querySelectorAll('button')];

				buttons.sort((a, b) => {

					const aValue = (a.getAttribute('title') || a.dataset.optionValue || '').toUpperCase();
					const bValue = (b.getAttribute('title') || b.dataset.optionValue || '').toUpperCase();

					let ia = order.indexOf(aValue);
					let ib = order.indexOf(bValue);

					if (ia === -1) ia = 9999;
					if (ib === -1) ib = 9999;

					return ia - ib;
				});

				buttons.forEach(btn => container.appendChild(btn));
			});

		}

		sortCardSizes();
		setTimeout( sortCardSizes, 100);
		
		document.addEventListener('DOMContentLoaded', () => {
			refreshVariants();

			const variantContainer = document.querySelector('sht-variant-radios');

			if (!variantContainer) return;

			const observer = new MutationObserver(() => {
				refreshVariants();
			});

			observer.observe(variantContainer, {
				childList: true,
				subtree: true
			});
		});
		document.addEventListener('variant:change', refreshVariants);
		document.addEventListener('variant:changed', refreshVariants);
		document.addEventListener('product:variant-change', refreshVariants);

	  //ANTIGUO ORDEN DE TALLAS
	  var items = $('.swatches-wrapper[data-name="Talla"] .swatch-element');
	  var items_tallas = $('.talla.options.indiv-product__swatches');
	  var order = [ 
		'XL','L','M','M/L','S','S/M','XS','44D','44C','44B','44A','44','43D','43C','43B','43A','43','T42D','T42C','T42B','T42A','42D','42C','42B','42A','42','41D','41C','41B','41A','41','T40D','T40C','T40B','T40A','40D','40C','40B','40A','40','39D','39C','39B','39A','39','T38D','T38C','T38B','T38A','38D','38C','38B','38A','38','37D','37C','37B','37A','37','T36D','T36C','T36B','T36A','36D','36C','36B','36A','36','35D','35C','35B','35A','35','T34D','T34C','T34B','T34A','34D','34C','34B','34A','34','33D','33C','33B','33A','33','T32D','T32C','T32B','T32A','32D','32C','32B','32A','32'
	].reverse();
	  order.forEach( function ( item ) { 
		  items.each( function ( index, it ) {
		  if( $(it).data('value') == item ) {
			var $li = $(it).detach();
			$('.swatches-wrapper[data-name="Talla"] .swatch.clearfix').prepend( $li );
		  }
		} );
	  });
	  
	  items_tallas.each( function ( _in, item_wrap_talla ) {
		order.forEach( function ( item ) {
			//console.log( item_wrap_talla, item );
			$(item_wrap_talla).find('.position-relative').each( function ( index, it ) {
			  
			  if( $(it).find('input').val() == item ) {
				var $li = $(it).detach();
				$(item_wrap_talla).prepend( $li );
			  } 
			} );
		} );
	  } ); 


	  	
		

		function autoSelectNA() {
			document.querySelectorAll('.combowise-box-row').forEach(function (row) {

			const selector = row.querySelector('.combowise-box-selector-dataset');
			if (!selector) return;

			const option = Array.from(selector.querySelectorAll('option'))
				.find(option => option.value !== '');

			if (!option) return;

			const variantTitle = (option.dataset.title || '').toLowerCase();

			// Revisar cada grupo (Color / Talla) por separado
			row.querySelectorAll('.combowise__input--radio').forEach(function (fieldset) {

				const radios = Array.from(
				fieldset.querySelectorAll('.combowise__input--radio-radio')
				);

				if (!radios.length) return;

				// Obtener las opciones disponibles de este grupo
				const availableRadios = radios.filter(function (radio) {
				return !radio.disabled && radio.value.trim() !== '';
				});

				// Solo actuar si este grupo tiene UNA sola opción
				if (availableRadios.length !== 1) return;

				const radio = availableRadios[0];

				// La única opción debe ser N/A
				if (radio.value.trim().toLowerCase() !== 'n/a') return;

				// Seleccionar N/A
				if (!radio.checked) {
				radio.checked = true;

				radio.dispatchEvent(new Event('change', {
					bubbles: true
				}));

				radio.dispatchEvent(new Event('click', {
					bubbles: true
				}));
				}

				// Ocultar SOLO este grupo
				fieldset.style.display = 'none';

			});

			});
		}

		// Ejecutar al cargar
		autoSelectNA();

		// ComboWise puede cargar/modificar el HTML dinámicamente
		const observer = new MutationObserver(function () {
			autoSelectNA();
		});

		observer.observe(document.body, {
			childList: true,
			subtree: true
		});

	  
		$('.swatches-wrapper[data-name="Color"] .swatch-element:first-child label').click();
		$('.swatches-wrapper[data-name="Talla"] .swatch-element:first-child label').click();
	  
		if( $('.swatches-wrapper[data-name="Color"] .swatch-element' ).length == 1 ) {
		  var value_color = $('.swatches-wrapper[data-name="Color"] .swatch-element' ).data('value');
		  if( value_color == 'N/A' ) {
			$('.swatches-wrapper[data-name="Color"]' ).fadeOut(0);
		  }
		}
	  
		if( $('.swatches-wrapper[data-name="Talla"] .swatch-element' ).length == 1 ) {
		  var value_color = $('.swatches-wrapper[data-name="Talla"] .swatch-element' ).data('value');
		  if( value_color == 'N/A' ) {
			$('.swatches-wrapper[data-name="Talla"]' ).fadeOut(0);
		  }
		}
	  
		//listar departamentos
		var select01 = '';  
		$.each(departamentos, function(i, obj) {
			select01 = '<option value="'+ departamentos[i].coddepartamento + '">' + departamentos[i].departamento + '</option>';
			$('#cart_attibutes_departamento').append(select01);
		});
	  
		jQuery(".product-page--pricing").detach().prependTo('.product-description-main-wrapper');
		jQuery("h1.custom-font.product-description-header").detach().prependTo('.product-description-main-wrapper');
	  

		
		//listar provincias por departamento
		$('#cart_attibutes_departamento').on('change', function() {
			
			//limpiar los selects 
			$('#cart_attibutes_provincia').find('option').remove();
			$('#cart_attibutes_distrito').find('option').remove();
			
			var iddep = this.value;
			var select02 = '';  
			
			var provincias_result = jQuery.grep(provincias, function (obj) {
				return obj[iddep];
					});
			
			//console.log( JSON.stringify(provincias_result, null, '\t') );
			//console.log( JSON.stringify(provincias_result[0][iddep], null, '\t') );
			
			var provincias_result_array = provincias_result[0][iddep];
			
			$.each(provincias_result_array, function(i, obj) {
				select02 = '<option value="'+ provincias_result_array[i].codprovincia + '">' + provincias_result_array[i].provincia + '</option>';
				$('#cart_attibutes_provincia').append(select02);      
			});
			
			//cargar los distritos
			$('#cart_attibutes_provincia').trigger('change');
			
		});
		
		//listar distritos por provincia
		$('#cart_attibutes_provincia').on('change', function() {
			
			//limpiar el select de distritos    
			$('#cart_attibutes_distrito').find('option').remove();
			
			var idpro = this.value;
			var select03 = '';  
			
			var distritos_result = jQuery.grep(distritos, function (obj) {
				return obj[idpro];
					});
			
			//console.log( JSON.stringify(distritos_result, null, '\t') );
			//console.log( JSON.stringify(distritos_result[0][idpro], null, '\t') );
			
			var distritos_result_array = distritos_result[0][idpro];
			
			$.each(distritos_result_array, function(i, obj) {
				select03 = '<option value="'+ distritos_result_array[i].coddistrito + '">' + distritos_result_array[i].distrito + '</option>';
				$('#cart_attibutes_distrito').append(select03);     
			});
			
		});
		
		//seleccionar por defecto LIMA
		var current_departamento = $('#cart_attibutes_departamento').data('current');;
		var current_provincia = $('#cart_attibutes_provincia').data('current');
		var current_distrito = $('#cart_attibutes_distrito').data('current');
			
			
		if( !current_departamento ) current_departamento = 14;
		if( !current_provincia ) current_provincia = 1406;
		if( !current_distrito ) current_distrito = 140613;
			
		//console.log( current_departamento, current_provincia, current_distrito );
			
		$('#cart_attibutes_departamento option[value="'+ current_departamento +'"]').attr("selected",true);
		$('#cart_attibutes_departamento').trigger('change');
		
		//seleccionar por defecto LIMA
		$('#cart_attibutes_provincia option[value="'+ current_provincia +'"]').attr("selected",true);
		$('#cart_attibutes_provincia').trigger('change');
		
		//seleccionar por defecto LA MOLINA
		$('#cart_attibutes_distrito option[value="'+ current_distrito +'"]').attr("selected",true);
			
		$( document ).on( 'keyup', '.only_numbers', function () { 
				this.value = this.value.replace(/[^0-9\.]/g,'');
		});
			
		var cambio_factura = function () {
			var deseo_factura = jQuery( '#cart_attibutes_deseo_factura' ).val();
			
			if( deseo_factura == 'Si' ) {
				$('#show_factura').removeClass('hide');
			}

			if( deseo_factura == 'No' ) {
				$('#show_factura').addClass('hide'); 
				jQuery( '#cart_attibutes_ruc' ).val('');
				jQuery( '#cart_attibutes_razon_social' ).val('');
			}  
		};
		cambio_factura();
		$( document ).on( 'change', '#cart_attibutes_deseo_factura', function () {
				cambio_factura();
		});
			
		var cambio_envio = function () {
				var metodo_envio = jQuery( '[name="attributes[metodo_envio]"]:checked' ).val();
			if( metodo_envio == 'Despacho a domicilio' ) {
					$('#show_retiro').addClass('hide'); 
					$('#show_despacho').removeClass('hide');
				
					$('[name="attributes[recoger_tienda]"]').prop('checked', false);
				}
				if( metodo_envio == 'Retiro en tienda' ) {
					$('#show_retiro').removeClass('hide'); 
					$('#show_despacho').addClass('hide');
					
					$('#cart_attibutes_ciudad').val('');
					$('#cart_attibutes_calle').val('');
					$('#cart_attibutes_apartamento').val('');
				}  
		};
		cambio_envio();
		$( document ).on( 'change', '[name="attributes[metodo_envio]"]', function () {
				cambio_envio();
		});
	  
	  $('.open-tallas').magnificPopup({
			 type:'image',
		});
		$('.open-video').magnificPopup({
			 type:'iframe',
		});

	  
	  if( jQuery('#locales-carousel').length ) {
			$('#locales-carousel').flexslider({
					animation: "slide",
					slideshowSpeed: 4800,
					animationSpeed:400,
					controlNav: false,
					animationLoop: true,
					slideshow: false,
					itemWidth: window.innerWidth >= 1440 ? 220 : ( window.innerWidth > 1300 ? 180 : (window.innerWidth < 1024 ? 170 : 180) ),
					itemMargin: 0,
					minItems: 1,
					asNavFor: '#locales-slider'
				});
				$('#locales-slider').flexslider({
					animation: "slide",
					slideshowSpeed: 4800,
					animationSpeed:400,
					controlNav: false,
					directionNav: false,
					animationLoop: true,
					slideshow: false,
					sync: "#locales-carousel"
				});
	  }
	  
	  jQuery( '#cart_submit' ).addClass( 'validar_campos' );

	  jQuery( document ).on( 'click', '#cart_submit', async function ( e ) {
		  var $btn = jQuery( this );
		  if ( $btn.hasClass( 'validar_campos' ) ) {
			  e.preventDefault();
			  e.stopPropagation();

			  $cart_attibutes_telefono = jQuery( '#cart_attibutes_telefono' );
			  $cart_attibutes_dni = jQuery( '#cart_attibutes_dni' );
			  $metodo_envio = jQuery('[name="attributes[metodo_envio]"]:checked');

			  //$cart_attibutes_telefono.change();

			  var fail_validation = false;
			  if( !$cart_attibutes_telefono.val().trim() ) {
				  $cart_attibutes_telefono.next().remove();
				  $cart_attibutes_telefono.after('<span style="color: red; ">Debes ingresar un teléfono</span>');
				  setTimeout(function(){
					  $cart_attibutes_telefono.next().remove();
				  }, 5000 );
				  fail_validation = true;

				  $([document.documentElement, document.body]).animate({
					  scrollTop: $cart_attibutes_telefono.offset().top - jQuery('.sticky-header-wrapper').height() - 60
				  }, 1000);
			  }
			  if( !$cart_attibutes_dni.val().trim() ) {
				  $cart_attibutes_dni.next().remove();
				  $cart_attibutes_dni.after('<span  style="color: red; ">Debes ingresar un DNI</span>');
				  setTimeout(function(){
					  $cart_attibutes_dni.next().remove();
				  }, 5000 );
				  fail_validation = true;

				  $([document.documentElement, document.body]).animate({
					  scrollTop: $cart_attibutes_dni.offset().top - jQuery('.sticky-header-wrapper').height() - 60
				  }, 1000);
			  }
			  if( $metodo_envio.length == 0 ) {
				$('label[for="cart_attibutes_metodo_envio"]').parent().next().remove();
				$('label[for="cart_attibutes_metodo_envio"]').parent().after('<span  style="color: red; ">Debes seleccionar el método de envío</span>');
				setTimeout(function(){
					$('label[for="cart_attibutes_metodo_envio"]').parent().next().remove();
				}, 5000 );
				fail_validation = true;
			  } else {
				if( $metodo_envio.val() == 'Retiro en tienda' ) {
					$recoger_tienda = jQuery('[name="attributes[recoger_tienda]"]:checked');
					if( $recoger_tienda.length == 0 ) {
					  $('#show_retiro > .row').next().remove();
					  $('#show_retiro > .row').after('<span  style="color: red; ">Debes seleccionar recoger en tienda</span>');
					  setTimeout(function(){
						  $('#show_retiro > .row').next().remove();
					  }, 5000 );
					  fail_validation = true;
					}
				}
				if( $metodo_envio.val() == 'Despacho a domicilio' ) {
				  $cart_attibutes_ciudad = jQuery( '#cart_attibutes_ciudad' );
				  $cart_attibutes_calle = jQuery( '#cart_attibutes_calle' );
				  
				  if( !$cart_attibutes_ciudad.val().trim() ) {
					  $cart_attibutes_ciudad.next().remove();
					  $cart_attibutes_ciudad.after('<span style="color: red; ">Debes ingresar una cuidad</span>');
					  setTimeout(function(){
						  $cart_attibutes_ciudad.next().remove();
					  }, 5000 );
					  fail_validation = true;

					  $([document.documentElement, document.body]).animate({
						  scrollTop: $cart_attibutes_ciudad.offset().top - jQuery('.sticky-header-wrapper').height() - 60
					  }, 1000);
				  }
				  if( !$cart_attibutes_calle.val().trim() ) {
					  $cart_attibutes_calle.next().remove();
					  $cart_attibutes_calle.after('<span style="color: red; ">Debes ingresar una calle</span>');
					  setTimeout(function(){
						  $cart_attibutes_calle.next().remove();
					  }, 5000 );
					  fail_validation = true;

					  $([document.documentElement, document.body]).animate({
						  scrollTop: $cart_attibutes_calle.offset().top - jQuery('.sticky-header-wrapper').height() - 60
					  }, 1000);
				  }
				}
			  }
			
			
			  //console.log(fail_validation);
			  if ( !fail_validation ) {
				  $btn.removeClass('validar_campos');
					await window.validate_envio();
				  $btn.click();
			  } else {  
				await window.validate_envio();
			  }
		  }
	  } );

	  function bloquearReparto() {

		$('.cart-item').each(function () {

			var $item = $(this);
			var url = $item.find('a[href*="/products/"]').attr('href') || '';

			if (url.includes('/products/reparto')) {

				// Cantidad fija
				var $input = $item.find('.js-quantity-input');

				$input
					.val(1)
					.prop('readonly', true)
					.attr({
						min: 1,
						max: 1
					});

				// Ocultar + y -
				$item.find('.js-quantity-btn-minus').hide();
				$item.find('.js-quantity-btn-plus').hide();

				// Ocultar botón eliminar
				$item.find('sht-cart-rmv-btn').hide();

				// Seguridad adicional
				$input.on('input change', function () {
					$(this).val(1);
				});
			}

		});
	}

	bloquearReparto();

	  window.validate_envio = async function() {
		  var note = jQuery('#note').val();
		  var telefono = jQuery('#cart_attibutes_telefono').val();
		  var dni = jQuery('#cart_attibutes_dni').val();
		  var ruc = jQuery('#cart_attibutes_ruc').val();
		  var razon_social = jQuery('#cart_attibutes_razon_social').val();
		  var deseo_factura = jQuery('#cart_attibutes_deseo_factura').val();

		  var metodo_envio = jQuery('[name="attributes[metodo_envio]"]:checked').val();
		  var recoger_tienda = jQuery('[name="attributes[recoger_tienda]"]:checked').val();
		  var pais = jQuery('#cart_attibutes_pais').val();


		  var coddepartamento = jQuery('#cart_attibutes_departamento').val();
		  var codprovincia = jQuery('#cart_attibutes_provincia').val();
		  var coddistrito = jQuery('#cart_attibutes_distrito').val();

		  var departamento = jQuery('#cart_attibutes_departamento  option:selected').html();
		  var provincia = jQuery('#cart_attibutes_provincia option:selected').html();
		  var distrito = jQuery('#cart_attibutes_distrito option:selected').html();
		  var ciudad = jQuery('#cart_attibutes_ciudad').val();
		  var calle = jQuery('#cart_attibutes_calle').val();
		  var apartamento = jQuery('#cart_attibutes_apartamento').val();

		  var es_lima_metropolitana = 0;
		  var es_lima_10 = 0;
		  var es_lima_15 = 0;
		  var es_lima_20 = 0;
		  var es_lima_provincias = 0;
		  var es_provincias = 0;
		  var es_retiro_en_tienda = 0;
		  var es_envio_gratis = 0;

		  var distritos_lima_15 = ['Independencia', 'La Molina', 'Los Olivos', 'Rimac', 'San Juan de Miraflores', 'San Martin de Porres', 'Santa Anita', 'Villa El Salvador', 'Villa Maria del Triunfo'];
		  var distritos_lima_20 = ['Ancon', 'Ate', 'Carabayllo', 'Chaclacayo', 'Chorrillos', 'Cieneguilla', 'Comas', 'El Agustino', 'Lurigancho', 'Lurin', 'Pachacamac', 'Pucusana', 'Puente Piedra', 'Punta Hermosa', 'Punta Negra', 'San Bartolo', 'San Juan de Lurigancho', 'Santa Maria del Mar', 'Santa Rosa'];
		  var distritos_lima_10 = ['Barranco', 'Breña', 'Jesus Maria', 'La Victoria', 'Lima', 'Lince', 'Magdalena del Mar', 'Miraflores', 'Pueblo Libre', 'San Borja', 'San Isidro', 'San Luis', 'San Miguel', 'Santiago de Surco', 'Surquillo' ];



		  let formData2 = {
			  updates: {
				  //LIMA 10
				  44678385402088: 0,
				  //LIMA 15
				  44678388777192: 0,
				  //LIMA 20
				  44678386352360: 0,

				  //LIMA METROPOLITANA
				  42888979808488: 0,
				  42889009496296: 0,
				  42888979841256: 0,
				  42888986231016: 0,
				  42890141073640: 0,
			  }
		  };
		  var carrito = await fetch(window.Shopify.routes.root + 'cart.js', {
				  method: 'GET',
				  headers: {
					  'Content-Type': 'application/json'
				  },
				  //body: JSON.stringify(formData)
			  })
			  .then(response => {
				  return response.json();
			  })
			  .catch((error) => {
				  console.error('Error:', error);
			  });
		  //console.log(carrito);
		  //console.log(33, carrito.total_price);
		  var total_price = carrito.total_price;

		  carrito.items.forEach(function(item) {
			  if (item.id == 44678385402088) {
				  total_price -= item.price;
			  }
			  if (item.id == 44678388777192) {
				  total_price -= item.price;
			  }
			  if (item.id == 44678386352360) {
				  total_price -= item.price;
			  }
			  if (item.id == 42888979808488) {
				  total_price -= item.price;
			  }
			  if (item.id == 42889009496296) {
				  total_price -= item.price;
			  }
			  if (item.id == 42888979841256) {
				  total_price -= item.price;
			  }

		  });

		  //console.log(33, total_price);

		  if (metodo_envio == 'Retiro en tienda') {
			  es_retiro_en_tienda = 1;
			  es_lima_metropolitana = 0;
					  es_lima_10 = 0;
					  es_lima_15 = 0;
					  es_lima_20 = 0;
			  es_lima_provincias = 0;
			  es_provincias = 0;
			  es_envio_gratis = 0;
		  } else {
			  if (departamento != 'Lima') {
				  es_retiro_en_tienda = 0;
				  es_lima_metropolitana = 0;
					  es_lima_10 = 0;
					  es_lima_15 = 0;
					  es_lima_20 = 0;
				  es_lima_provincias = 0;
				  es_provincias = 1;
				  es_envio_gratis = 0;
			  } else {
				  if (provincia != 'Lima') {
					  es_retiro_en_tienda = 0;
					  es_lima_metropolitana = 0;
					  es_lima_10 = 0;
					  es_lima_15 = 0;
					  es_lima_20 = 0;
					  es_lima_provincias = 1;
					  es_provincias = 0;
					  es_envio_gratis = 0;
				  } else {
					  es_retiro_en_tienda = 0;
					  es_lima_provincias = 0;
					  es_provincias = 0;
					  es_envio_gratis = 0;
					  es_lima_metropolitana = 1;
					  es_lima_10 = 0;
					  es_lima_15 = 0;
					  es_lima_20 = 0;

						//console.log( distrito );
					  if( distritos_lima_10.includes( distrito.trim() ) ) {
					  	es_lima_10 = 1;
					  	es_lima_metropolitana = 0;
					  }

					  if( distritos_lima_15.includes( distrito.trim() ) ) {
					  	es_lima_15 = 1;
					  	es_lima_metropolitana = 0;
					  }

					  if( distritos_lima_20.includes( distrito.trim() ) ) {
					  	es_lima_20 = 1;
					  	es_lima_metropolitana = 0;
					  }
				  }
			  }
			  if (total_price >= 14900) {
				  es_retiro_en_tienda = 0;
				  es_lima_metropolitana = 0;
					  es_lima_10 = 0;
					  es_lima_15 = 0;
					  es_lima_20 = 0;
				  es_lima_provincias = 0;
				  es_provincias = 0;
				  es_envio_gratis = 1;
			  }
		  }
		
		
		  let formData = {
			  updates: {
					  //LIMA 10
					  44678385402088: es_lima_10,
					  //LIMA 15
					  44678388777192: es_lima_15,
					  //LIMA 20
					  44678386352360: es_lima_20,
					  
					  42888979808488: es_lima_metropolitana,
					  42889009496296: es_lima_provincias,
					  42888979841256: es_provincias,
					  42888986231016: es_retiro_en_tienda,
					  42890141073640: es_envio_gratis,
				  },
				  'note': note,
				  "attributes": {
					  'telefono': telefono,
					  'note': note,
					  'dni': dni,
					  'ruc': ruc,
					  'razon_social': razon_social,
					  'deseo_factura': deseo_factura,

					  'metodo_envio': metodo_envio,
					  'pais': metodo_envio == 'Retiro en tienda' ? '' : pais,
					  'coddepartamento': metodo_envio == 'Retiro en tienda' ? '' : coddepartamento,
					  'codprovincia': metodo_envio == 'Retiro en tienda' ? '' : codprovincia,
					  'coddistrito': metodo_envio == 'Retiro en tienda' ? '' : coddistrito,
					  'departamento': metodo_envio == 'Retiro en tienda' ? '' : departamento,
					  'provincia': metodo_envio == 'Retiro en tienda' ? '' : provincia,
					  'distrito': metodo_envio == 'Retiro en tienda' ? '' : distrito,
					  'ciudad': metodo_envio == 'Retiro en tienda' ? '' : ciudad,
					  'calle': metodo_envio == 'Retiro en tienda' ? '' : calle,
					  'apartamento': metodo_envio == 'Retiro en tienda' ? '' : apartamento,
					  'recoger_tienda': metodo_envio == 'Despacho a domicilio' ? '' : recoger_tienda,
				  }
		  };
		
		 var update = await fetch(window.Shopify.routes.root + 'cart/update.js', {
		   method: 'POST',
				  headers: {
					  'Content-Type': 'application/json'
				  },
				  body: JSON.stringify(formData)
			  })
			  .then(response => {
				document.dispatchEvent(new Event('cart:update'));
				setTimeout(function () {
					bloquearReparto();
				}, 1000);
				  return response.json();
			  })
			  .catch((error) => {
				  console.error('Error:', error);
			  });
		  return update;
	  }
			
		$( document ).on( 'change', '[name="attributes[metodo_envio]"], [name="attributes[recoger_tienda]"], #note, #cart_attibutes_telefono, #cart_attibutes_departamento, #cart_attibutes_provincia, #cart_attibutes_distrito, #cart_attibutes_ciudad, #cart_attibutes_calle, #cart_attibutes_apartamento, #cart_attibutes_dni, #cart_attibutes_ruc, #cart_attibutes_razon_social, #cart_attibutes_deseo_factura', function () {
			var note = jQuery( '#note' ).val();
			var telefono = jQuery( '#cart_attibutes_telefono' ).val();
			var dni = jQuery( '#cart_attibutes_dni' ).val();
			var ruc = jQuery( '#cart_attibutes_ruc' ).val();
			var razon_social = jQuery( '#cart_attibutes_razon_social' ).val();
			var deseo_factura = jQuery( '#cart_attibutes_deseo_factura' ).val();
			
			var metodo_envio = jQuery( '[name="attributes[metodo_envio]"]:checked' ).val();
			var recoger_tienda = jQuery( '[name="attributes[recoger_tienda]"]:checked' ).val();
			var pais = jQuery( '#cart_attibutes_pais' ).val();
			
			
			var coddepartamento = jQuery( '#cart_attibutes_departamento' ).val();
			var codprovincia = jQuery( '#cart_attibutes_provincia' ).val();
			var coddistrito = jQuery( '#cart_attibutes_distrito' ).val();
			
			var departamento = jQuery( '#cart_attibutes_departamento  option:selected' ).html();
			var provincia = jQuery( '#cart_attibutes_provincia option:selected' ).html();
			var distrito = jQuery( '#cart_attibutes_distrito option:selected' ).html();
			var ciudad = jQuery( '#cart_attibutes_ciudad' ).val();
			var calle = jQuery( '#cart_attibutes_calle' ).val();
			var apartamento = jQuery( '#cart_attibutes_apartamento' ).val();
			
			var es_lima_metropolitana = 0;
		    var es_lima_10 = 0;
		    var es_lima_15 = 0;
		    var es_lima_20 = 0;
			var es_lima_provincias = 0;
			var es_provincias = 0;
			var es_retiro_en_tienda = 0;
			var es_envio_gratis = 0;

			var distritos_lima_15 = ['Independencia', 'La Molina', 'Los Olivos', 'Rimac', 'San Juan de Miraflores', 'San Martin de Porres', 'Santa Anita', 'Villa El Salvador', 'Villa Maria del Triunfo'];
			var distritos_lima_20 = ['Ancon', 'Ate', 'Carabayllo', 'Chaclacayo', 'Chorrillos', 'Cieneguilla', 'Comas', 'El Agustino', 'Lurigancho', 'Lurin', 'Pachacamac', 'Pucusana', 'Puente Piedra', 'Punta Hermosa', 'Punta Negra', 'San Bartolo', 'San Juan de Lurigancho', 'Santa Maria del Mar', 'Santa Rosa'];
			var distritos_lima_10 = ['Barranco', 'Breña', 'Jesus Maria', 'La Victoria', 'Lima', 'Lince', 'Magdalena del Mar', 'Miraflores', 'Pueblo Libre', 'San Borja', 'San Isidro', 'San Luis', 'San Miguel', 'Santiago de Surco', 'Surquillo' ];


		  
			jQuery('#cart_submit').addClass('validar_campos');
			 
			 
			let formData = {
				updates: {
					//LIMA 10
					44678385402088: 0,
					//LIMA 15
					44678388777192: 0,
					//LIMA 20
					44678386352360: 0,
					
					42888979808488: 0,
					42889009496296: 0,
					42888979841256: 0,
					42888986231016: 0,
					42890141073640: 0,
				}
			};
		  var carrito = fetch(window.Shopify.routes.root + 'cart.js', {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json'
				},
				//body: JSON.stringify(formData)
			})
			.then(response => {
				return response.json();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
		  
			carrito.then( resJson => {
				//console.log( 33, resJson.total_price );
				var total_price = resJson.total_price;
			  
			  resJson.items.forEach( function ( item ) {
				if( item.id == 44678385402088 ){
				  total_price-= item.price;
				}
				if( item.id == 44678388777192 ){
				  total_price-= item.price;
				}
				if( item.id == 44678386352360 ){
				  total_price-= item.price;
				}
				if( item.id == 42888979808488 ){
				  total_price-= item.price;
				}
				if( item.id == 42889009496296 ){
				  total_price-= item.price;
				}
				if( item.id == 42888979841256 ){
				  total_price-= item.price;
				}
				
			  } );
			  
				//console.log( 33, total_price );
				if( metodo_envio == 'Retiro en tienda' ) {
					es_retiro_en_tienda = 1;
					es_lima_metropolitana = 0;
					  es_lima_10 = 0;
					  es_lima_15 = 0;
					  es_lima_20 = 0;
					es_lima_provincias = 0;
					es_provincias = 0;
					es_envio_gratis = 0;
				} else {
					if ( departamento != 'Lima' ) {
						es_retiro_en_tienda = 0;
						es_lima_metropolitana = 0;
					  es_lima_10 = 0;
					  es_lima_15 = 0;
					  es_lima_20 = 0;
						es_lima_provincias = 0;
						es_provincias = 1;
						es_envio_gratis = 0;
					} else {
						if ( provincia != 'Lima' ) {
							es_retiro_en_tienda = 0;
							es_lima_metropolitana = 0;
					  es_lima_10 = 0;
					  es_lima_15 = 0;
					  es_lima_20 = 0;
							es_lima_provincias = 1;
							es_provincias = 0;
							es_envio_gratis = 0;
						} else {
							es_retiro_en_tienda = 0;
							es_lima_provincias = 0;
							es_provincias = 0;
							es_envio_gratis = 0;
							es_lima_metropolitana = 1;
							es_lima_10 = 0;
							es_lima_15 = 0;
							es_lima_20 = 0;
							if( distritos_lima_10.includes( distrito.trim() ) ) {
								es_lima_10 = 1;
								es_lima_metropolitana = 0;
							}

							if( distritos_lima_15.includes( distrito.trim() ) ) {
								es_lima_15 = 1;
								es_lima_metropolitana = 0;
							}

							if( distritos_lima_20.includes( distrito.trim() ) ) {
								es_lima_20 = 1;
								es_lima_metropolitana = 0;
							}
						}
					}
					if( total_price >= 14900 ) {
							es_retiro_en_tienda = 0;
							es_lima_metropolitana = 0;
							  es_lima_10 = 0;
							  es_lima_15 = 0;
							  es_lima_20 = 0;
							es_lima_provincias = 0;
							es_provincias = 0;
							es_envio_gratis = 1;
					}
				}

				var formData = {
					//"requires_shipping": $( '[name="attributes[metodo_envio]"]:checked' ).val() == 'Retiro en tienda',
					updates: {
						//LIMA 10
						44678385402088: es_lima_10,
						//LIMA 15
						44678388777192: es_lima_15,
						//LIMA 20
						44678386352360: es_lima_20,

						42888979808488: es_lima_metropolitana,
						42889009496296: es_lima_provincias,
						42888979841256: es_provincias,
						42888986231016: es_retiro_en_tienda,
						42890141073640: es_envio_gratis,
					},
					'note': note,
					"attributes": {
							'telefono': telefono,
							'note': note,
							'dni': dni,
							'ruc': ruc,
							'razon_social': razon_social,
							'deseo_factura': deseo_factura,

							'metodo_envio': metodo_envio,
							'pais': metodo_envio == 'Retiro en tienda' ? '' : pais,
							'coddepartamento': metodo_envio == 'Retiro en tienda' ? '' : coddepartamento,
							'codprovincia': metodo_envio == 'Retiro en tienda' ? '' : codprovincia,
							'coddistrito': metodo_envio == 'Retiro en tienda' ? '' : coddistrito,
							'departamento': metodo_envio == 'Retiro en tienda' ? '' : departamento,
							'provincia': metodo_envio == 'Retiro en tienda' ? '' : provincia,
							'distrito': metodo_envio == 'Retiro en tienda' ? '' : distrito,
							'ciudad': metodo_envio == 'Retiro en tienda' ? '' : ciudad,
							'calle': metodo_envio == 'Retiro en tienda' ? '' : calle,
							'apartamento': metodo_envio == 'Retiro en tienda' ? '' : apartamento,
							'recoger_tienda': metodo_envio == 'Despacho a domicilio' ? '' : recoger_tienda,
					}
				};



				
				$.post( window.Shopify.routes.root + 'cart/update.js', formData ).done(function ( EE ) {
					//console.log( EE );
					document.dispatchEvent(new Event('cart:update'));
					setTimeout(function () {
						bloquearReparto();
					}, 1000);
				})
				.catch((error) => {
					console.error('Error:', error);
				});
				
			})
			.catch((error) => {
				console.error('Error:', error);
			});
		});
		
	});
})(jQuery); 